<template>
  <b-modal
      id="tint-world-modal"
      :hide-header="true"
      :hide-footer="true"
  >
    <!-- Modal Header / Logo Contact Info -->
    <div class="modal-header">
      <div class="dropdown-ctn appt-modal-ctn">
        <div class="modal-logo">
          <a class="logo" href="/index.php">
            <img style="width: 100%" src="https://res.cloudinary.com/tint-world/image/upload/s--YIdTz7ra--/f_auto,fl_lossy,q_auto:best/v1647972234/custom-assets/Tint%20World%20Brand/tw-logo-horizontal-web.png"/>
          </a>
        </div>
        <div class="call-info">
          <span class="lbl-call">Call today!</span>
          <span class="lbl-call-number">800.767.8468</span>
        </div>
        <div class="close-btn c-pointer" @click="hideModal">
          <CloseImg></CloseImg>
        </div>
      </div>
    </div>
    <ApptModal v-if="appt_modal.active"></ApptModal>
    <QuoteModal v-if="quote_modal.active"></QuoteModal>
    <!--<Checkout v-if="checkout_modal.active"></Checkout>-->
  </b-modal>
</template>

<script>
import CloseImg from './CloseImg'
//import ApptModal from "./appointment/ApptModal";
const ApptModal = () => import("./appointment/ApptModal.vue")
//import QuoteModal from "./quote/QuoteModalRev";
const QuoteModal = () => import("./quote/QuoteModalRev.vue")
//const Checkout = () => import("./checkout/Checkout.vue")
export default {
  components: {
    CloseImg,
    ApptModal,
    QuoteModal,
    //Checkout
  },
  data: () => {
    return {
     loaded_component: null,
    }
  },
  created() {
    this.$store.dispatch('loadFormServices');
    this.$store.commit('setFormProcessing',false);
    //@TODO - There is a low case situation where someone submits a PPC form, it fails, they stop trying, attempt on the main site, and the response/errors may persist in that section also
    if(this.$store.state.form_response.responseCode == 1){
      this.$store.commit('resetResponse');
    }
    //@TODO - Add load functions to look at Vuex for quoteComplete or appointmentComplete -> and reset the form for edge cases
  },
  computed: {
    //checkout_modal(){
      //return this.$store.state.components.checkout;
    //},
    appt_modal(){
      //@TODO - Could switch this to get/set mechanic and dynamic import the components here via a computed property and then mutate the 'active' state
      //@TODO - Could also look to make the mutation a promise, so we can setup a flow that will trigger the modal load, trigger dynamic import of modal content, then mutate after dynamic import
      return this.$store.state.components.appointment;
    },
    quote_modal(){
      /*
      @TODO - Alternative way to dynamically call components
      components: {
          my_component: () => import(path)
        }
       */
      //@TODO - Test this standard import to see if it's effective
      //@TODO - Technically both components should be lazy loaded anyway, so maybe this isn't overly helpful? At least it ensures the components will be lazy loaded? Though both components will lazy load on click
      return this.$store.state.components.quote;
    }
  },
  watch: {

  },
  methods: {
    hideModal(){
      this.$root.$emit('bv::hide::modal', 'tint-world-modal')
      this.$store.commit('CloseAllModals')
    }
  }
}
</script>
<style>
#tint-world-modal .dropdown-ctn {
  max-width: 1750px;
  margin: auto;
  position: relative;
}
#tint-world-modal .close-btn svg {
  vertical-align: top;
}
</style>